import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LanguageCode } from 'config/pais';

const initialState: { idioma: LanguageCode } = {
	idioma: 'es'
};

const idiomaRutaSlice = createSlice({
	name: 'idiomaRuta',
	initialState,
	reducers: {
		setIdiomaRuta: (state, action: PayloadAction<LanguageCode>) => {
			const rutaIdiomaState = action.payload;
			return { ...state, idioma: rutaIdiomaState };
		}
	}
});

export const { setIdiomaRuta } = idiomaRutaSlice.actions;

export default idiomaRutaSlice.reducer;
